import './Layout.scss'
import Header from './Header/Header'
import Footer from './Footer/Footer'
import Secure from './Secure/Secure'

const Layout = (props) => {
  const header = props.header !== undefined ? props.header : true
  const footer = props.footer !== undefined ? props.footer : true

  return (
    <div id="layout" className={`${props.fullsize === true ? 'fullsize' : ''}`}>
      <Secure authRequired={props.authRequired}>
        {header && <Header search={props.search} />}
        <div id="content-container">{props.children}</div>
        {footer && <Footer />}
      </Secure>
    </div>
  )
}

export default Layout
